var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"6","offset":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":_vm.loadingImage,"alt":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }